import { FC, forwardRef, Ref } from 'react';
import { ACTIONS, LocationPickerProps } from '@adsk/acc-locations-components';
import { RfiLocationId } from '../../sdk/types';
import { CommonFormField, CommonFormFieldProps } from './CommonFormField';
import { T } from '../../helpers';
import { LocationPicker } from '../LocationPicker';

export type LocationPickerFieldProps = CommonFormFieldProps & {
  onChangeLocationIds: (locationIds: RfiLocationId[]) => void;
  selectedLocationIds?: LocationPickerProps['selectedNodesIds'];
  hideIncludeSubLocations?: LocationPickerProps['hideIncludeSubLocations'];
  action?: LocationPickerProps['action'];
  ref?: Ref<HTMLDivElement>;
  'data-testId'?: string;
  disabled?: boolean;
  onClose?: LocationPickerProps['onClose'];
  onOpen?: LocationPickerProps['onOpen'];
};

export const LocationPickerField: FC<LocationPickerFieldProps> = forwardRef(
  (
    {
      onChangeLocationIds,
      selectedLocationIds = [],
      'data-testId': dataTestId = 'LocationPickerField',
      action = ACTIONS.ASSIGN,
      hideIncludeSubLocations = true,
      disabled = false,
      onClose,
      onOpen,
      style,
      error,
      ...commonFormFieldProps
    },
    ref,
  ) => (
    <CommonFormField
      label={T.translate('shared.location')}
      ref={ref}
      data-testid={dataTestId}
      error={error}
      {...commonFormFieldProps}
    >
      <LocationPicker
        disabled={disabled}
        onChangeLocationIds={onChangeLocationIds}
        hideIncludeSubLocations={hideIncludeSubLocations}
        selectedLocationIds={selectedLocationIds}
        includeSubLocations={false}
        action={action}
        onClose={onClose}
        onOpen={onOpen}
        style={style}
        invalid={!!error}
      />
    </CommonFormField>
  ),
);
